import { post } from 'modules/api';
/**
 *
 * @param {String} email
 * @returns Promise
 */
export const askForNewPassword = email => post(`password_reset/`, { email });
